import { fetcher } from "../fetcher";

type GetJournalsParams = {
  client_project_id: number;
  with: "author"[];
  order_by?: "id" | "title" | "created_at" | "updated_at";
};

type GetJournalParams = {
  id: number;
  with?: "author"[];
};

export const journalService = {
  getJournals: async (params?: GetJournalsParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("created_at" as const),
    };

    return await fetcher(`/journals/all`, {
      method: "GET",
      params: paramsWithDefaults,
      schema: journalItemsSchema,
    });
  },
  getJournal: async (payload: GetJournalParams) => {
    return await fetcher(`/journals/${payload.id}`, {
      method: "GET",
      params: payload,
      schema: journalItemSchema,
    });
  },
};
